/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createSessionStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/session-storage/index.tsx';
import type { WebStorageProvider } from '@jira/platform__browser-storage-providers/src/types.tsx';

// eslint-disable-next-line jira/web-storage/no-export-browser-storage-provider
export const storageProvider: WebStorageProvider =
	createSessionStorageProvider('sidebar-navigation');
